import React from 'react';
import breakpoints from '@constants/breakpoints';
import { IPrismicImage } from '@lib/prismic/types';
import PrismicImage from '@components/shared/images/atoms/Image/PrismicImage';
import classNames from 'classnames';
import { useTheme } from '@components/theme';
import { getResizedImageUrl } from '@lib/image';
import styles from './ShopHeroBanner.module.scss';

interface IShopHeroBannerProps {
  title: string;
  description?: string;
  image?: string | IPrismicImage | null;
}

const ShopHeroBanner = ({
  title,
  description,
  image
}: IShopHeroBannerProps) => {
  const theme = useTheme();
  const hasImage = !!image;

  const isImagePrismic = typeof image === 'object';

  return (
    <div className={classNames(
      styles.HeroBanner, {
      [styles.WithImage]: hasImage,
      [styles.WithoutImage]: !hasImage,
    }
    )}
    >
      {
        hasImage && (
          <>
            {
              isImagePrismic ? (
                <PrismicImage
                  className={styles.HeroImage}
                  image={image as IPrismicImage}
                  breakpoints={{
                    mobile: breakpoints.tablet
                  }}
                />
              ) : (
                <HeroImage image={image as string} />
              )
            }
          </>
        )
      }
      <div className={styles.TextWrapper}>
        <h1 className={theme.styles.Header}>{title}</h1>
        {description && (<p>{description}</p>)}
      </div>
    </div>
  );
};

function HeroImage({ image }: { image: string }) {
  return (
    <picture>
      <source
        media="(max-width: 600px)"
        srcSet={getResizedImageUrl({ url: image, width: 1200, quality: 80 })}
      />
      <source
        media="(max-width: 1100px)"
        srcSet={getResizedImageUrl({ url: image, width: 2200, quality: 80 })}
      />
      <img
        src={getResizedImageUrl({ url: image, width: 1600, quality: 90 })}
        alt="Merch Group"
        className={styles.HeroImage}
      />
    </picture>
  );
}

export default ShopHeroBanner;
